import FindLocation from './find-location';

export default FindLocation;
